import { isDevMode } from "@angular/core";
import { RouterReducerState, routerReducer } from "@ngrx/router-store";
import { ActionReducerMap, MetaReducer } from "@ngrx/store";
import * as fromApp from "./reducers/app.reducer";
import * as fromUser from "./reducers/user.reducer";
import * as fromIbge from "./reducers/ibge.reducer";

export interface State {
  router: RouterReducerState;
  [fromApp.appFeatureKey]: fromApp.State;
  [fromUser.userFeatureKey]: fromUser.State;
  [fromIbge.ibgeFeatureKey]: fromIbge.State;
}

export const reducers: ActionReducerMap<State> = {
  router: routerReducer,
  [fromApp.appFeatureKey]: fromApp.reducer,
  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromIbge.ibgeFeatureKey]: fromIbge.reducer
};

export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];
